import { CspConfigs } from "components/Integrations/types";
import { integrationOptionProvider } from "components/Integrations/utils/resourcesInstalledUtil";

import { AwsLambdaNotifierInstaller } from "../types";

export const awsLambdaNotifyInstaller = (
  cspConfigs: Pick<CspConfigs, "aws">
): AwsLambdaNotifierInstaller["notify"] => ({
  items: {
    functionCaller: {
      optionProvider: integrationOptionProvider("iam-write", [
        {
          firestoreRef: cspConfigs.aws,
          component: "function-caller",
          labelTitle: "AWS",
          keyPrefix: "aws",
        },
      ]),
    },
  },
  prerequisiteMessages: async (context) => {
    const optionsProvider = integrationOptionProvider("iam-write", [
      {
        firestoreRef: cspConfigs.aws,
        component: "function-caller",
        labelTitle: "AWS",
        keyPrefix: "aws",
      },
    ]);
    const options = await optionsProvider(context);
    if (!options.length)
      return (
        <div>Requires installed &quot;AWS Function Caller&quot; component</div>
      );
  },
});
